import { render, staticRenderFns } from "./CatalogCard.vue?vue&type=template&id=98d42938&"
import script from "./CatalogCard.vue?vue&type=script&lang=ts&"
export * from "./CatalogCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports